export * from './requestS';

export const motivosRejeicao = [
    'Proposta enviada é uma proposta de venda',
    'Formulário incompleto',
    'Melhoria no desenvolvimento da ideia para o projeto de inovação',
    'Solução proposta em desacordo com o edital',
    'Outros'
];